@for (item of items$ | async; track item?.uid) {
  <a [attr.aria-label]="item.iconName" href="{{ item.localizedUrl || item.url }}" target="_blank" rel="noopener">
    <mat-icon class="custom-icon" [svgIcon]="item.iconName"></mat-icon>
  </a>
}
